import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { swingCollectionsService } from "../../../services/swingCollections";
import { useInvalidate } from "../../../hooks/useInvalidate";

export function useUpdateCollection() {
  const invalidate = useInvalidate();

  return useMutation({
    mutationFn: async ({ collectionId, collectionName, videoIds }) => {
      try {
        return await swingCollectionsService.updateSwingCollection({
          collectionId,
          collectionName,
          videoIds,
        });
      } catch (error) {
        const msg = error?.message || "Failed to update collection";
        toast.error(msg);
        throw error;
      }
    },
    onSuccess: async () => {
      await invalidate([
        "getSwingCollection_key",
        "getAllSwingCollectionsByUserId_key",
        "getSwingListCollections_key",
      ]);
    },
  });
}
